export const StorageService = {
  getItem(key: string) {
    try {
      return JSON.parse(sessionStorage.getItem(key) || "null");
    } catch (_) {
      return null;
    }
  },

  setItem(key: string, value: unknown) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },

  removeItem(key: string) {
    sessionStorage.removeItem(key);
  }
};
